import Tippy, { TippyProps } from '@tippyjs/react';
import cn from 'classnames';
import * as React from 'react';

export interface ToolbarButtonProps {
  tooltip?: TippyProps;
  active?: boolean;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
  onClick?: () => void;
  icon?: React.ReactNode;
  label?: string;
  btnRef?: React.RefObject<HTMLButtonElement>;
}

export const ToolbarButton = ({
  icon,
  tooltip,
  onMouseDown,
  onClick,
  label,
  active = false,
  btnRef,
}: ToolbarButtonProps): JSX.Element => {
  const tooltipProps: TippyProps = {
    content: '',
    arrow: false,
    offset: [0, 17],
    delay: 0,
    duration: [200, 0],
    hideOnClick: false,
    trigger: 'hover',
    ...tooltip,
  };
  function handleKeyDown(e) {
    if (e.key === 'Enter') {
      onMouseDown?.(e);
    }
  }
  const button = (
    <button
      onMouseDown={onMouseDown}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      ref={btnRef}
      className={cn({
        'px-10 py-5 hover:bg-gray-100 rounded-sm flex items-center focus:shadow-outline': true,
        'text-primary-500': active,
      })}
    >
      <span className="flex"> {icon}</span>
      {label ? <span className="ml-8">{label}</span> : null}
    </button>
  );
  return tooltip ? <Tippy {...tooltipProps}>{button}</Tippy> : button;
};
